import React from 'react';
import { useDispatch } from 'react-redux';

import { removeCouponAction } from '@kfc-global/react-shared/redux/Actions/CartAction';

import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

const getCheckoutPriceSummaryView = (props, removeCouponHandler) => {
  return (
    <LazyLoaderWrapper
      {...props}
      testId='CheckPriceSummaryView'
      importPath='CHECKOUT_PRICE_SUMMARY_VIEW'
      removeCouponHandler={removeCouponHandler}
    ></LazyLoaderWrapper>
  );
};

const PriceSummary = props => {
  const { tenantId, basketId } = props?.checkoutDetails;

  const dispatch = useDispatch();

  const removeCouponHandler = couponCode => {
    dispatch(
      removeCouponAction({
        basketId,
        tenantId,
        couponCode,
      }),
    );
  };

  return getCheckoutPriceSummaryView(props, removeCouponHandler);
};

export default PriceSummary;
